/**
 * MapToolbar - Floating toolbar for map actions
 */

import React from 'react';
import { motion } from 'framer-motion';
import {
  ZoomIn,
  ZoomOut,
  Maximize2,
  Grid,
  Eye,
  EyeOff,
  Layers,
} from 'lucide-react';
import { useReactFlow } from '@xyflow/react';
import { useMapStore } from '../../stores/mapStore';

const MapToolbar = () => {
  const { zoomIn, zoomOut, fitView } = useReactFlow();
  const { settings, updateSettings } = useMapStore();

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="absolute left-4 bottom-20 z-20"
    >
      <div className="flex flex-col gap-1 p-1.5 bg-gray-800/90 backdrop-blur border border-gray-700 rounded-xl shadow-lg">
        {/* Zoom controls */}
        <button
          onClick={() => zoomIn({ duration: 300 })}
          className="p-2 rounded-lg hover:bg-gray-700 transition-colors"
          title="Zoom In"
        >
          <ZoomIn size={18} className="text-gray-400" />
        </button>

        <button
          onClick={() => zoomOut({ duration: 300 })}
          className="p-2 rounded-lg hover:bg-gray-700 transition-colors"
          title="Zoom Out"
        >
          <ZoomOut size={18} className="text-gray-400" />
        </button>

        <button
          onClick={() => fitView({ padding: 0.2, duration: 500 })}
          className="p-2 rounded-lg hover:bg-gray-700 transition-colors"
          title="Fit View"
        >
          <Maximize2 size={18} className="text-gray-400" />
        </button>

        <div className="h-px bg-gray-700 my-1" />

        {/* Toggle options */}
        <button
          onClick={() => updateSettings({ semanticZoom: !settings.semanticZoom })}
          className={`p-2 rounded-lg transition-colors ${
            settings.semanticZoom ? 'bg-indigo-600/20 text-indigo-400' : 'hover:bg-gray-700 text-gray-400'
          }`}
          title={settings.semanticZoom
            ? "Akıllı Zoom AÇIK - Uzaktan bakınca node'lar küçülür"
            : "Akıllı Zoom KAPALI - Node'lar her zaman tam boyutta"}
        >
          <Layers size={18} />
        </button>

        <button
          onClick={() => updateSettings({ showGhostNodes: !settings.showGhostNodes })}
          className={`p-2 rounded-lg transition-colors ${
            settings.showGhostNodes ? 'bg-purple-600/20 text-purple-400' : 'hover:bg-gray-700 text-gray-400'
          }`}
          title="Show Ghost Nodes"
        >
          {settings.showGhostNodes ? <Eye size={18} /> : <EyeOff size={18} />}
        </button>
      </div>
    </motion.div>
  );
};

export default MapToolbar;
